import React from 'react';
import { Tabs } from 'tea-component';
import { TAB_CONFIG } from './constants';
import ChannelLabel from '@op/components/ChannelLabel';

interface ITabBarProps {
  activeKey: string;
  onActive: (info: { id: string }) => void;
}

export default function TabBar({ activeKey, onActive }: ITabBarProps) {
  return (
    <Tabs
      ceiling
      tabs={TAB_CONFIG.map(t => {
        const key = t.key as any;
        return { id: t.key, label: <ChannelLabel iconStyle={{ width: 18, height: 18 }} key={key} channel_name={key} /> };
      })}
      animated={false}
      activeId={activeKey}
      onActive={onActive}
    />
  );
}
